import { SearchInput } from "../../common/ClearControls";
 import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import GoogleImageGalleryDialog from "../../ImageGallery/GoogleImageGalleryDialog";
import Cookies from "js-cookie";
import styles from "./ConsentTemplatesPage.module.scss";
import Header from "../Header/header";
import SetupSteps, { Step } from "../Register/SetupSteps/SetupSteps";
import { FiEdit2 } from "react-icons/fi";
import { toast } from "react-toastify";
import ImageGalleryV2 from "../../ImageGallery/imageGalleryV3";
import { HiSparkles } from "react-icons/hi2";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { useMutation } from "@tanstack/react-query";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

const GoogleIcon = ({ size = 22 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="#FFC107"
      d="M43.611 20.083H42V20H24v8h11.303C33.654 32.657 29.223 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917Z"
    />
    <path
      fill="#FF3D00"
      d="m6.306 14.691 6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4c-7.682 0-14.344 4.337-17.694 10.691Z"
    />
    <path
      fill="#4CAF50"
      d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44Z"
    />
    <path
      fill="#1976D2"
      d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l6.193 5.237C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917Z"
    />
  </svg>
);

// const STEPS: Step[] = [
//   { key: "practice", label: "Practice and personal info", path: "/practiceDetails" },
//   { key: "logo", label: "Logo Management", path: "/logoManagement" },
//   { key: "social", label: "Social Media Links", path: "/socialLinks" },
//   { key: "portfolio", label: "Portfolio Gallery", path: "/portfolioGallery" },
//   { key: "consent", label: "Consent Templates", path: "/consentTemplates" },
//   { key: "preview", label: "Preview & Complete", path: "/previewComplete" },
// ];

type Template = {
  id: number;
  name: string;
  body: string;
  level?: "user" | "practice";
  created_at?: string;
  is_default?: boolean;
  is_cloned?: boolean;
  parent_id?: number | null;
  category_id?: number | null;
  treatment_id?: number | null;
  treatment_ids?: number[];
  type?: string;
  practice_id?: number | null;
};

type Treatment = {
  id: number;
  category_type?: string;
  category_name?: string;
  description?: string;
  name?: string;
};

declare global {
  interface Window {
    CKEDITOR: any;
  }
}

export default function ConsentTemplatesPage() {
  const navigate = useNavigate();
  const editorRef = useRef<HTMLTextAreaElement | null>(null);
  const [mode, setMode] = useState<"empty" | "builder">("empty");
  const [builderTab, setBuilderTab] = useState<"manual" | "existing" | "generate">("existing");
  const [templates, setTemplates] = useState<Template[]>([]);
  const [practiceTemplates, setPracticeTemplates] = useState<Template[]>([]);
  const [treatments, setTreatments] = useState<Treatment[]>([]);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState<Template | null>(null);
  const [editTemplate, setEditTemplate] = useState<Template | null>(null);
  const [user, setUser] = useState<any>(null);
  const [selectedLevel, setSelectedLevel] = useState<"user" | "practice">("user");
  const [selectedTreatments, setSelectedTreatments] = useState<number[]>([]);
  const [treatmentSearch, setTreatmentSearch] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showAiSaveConfirm, setShowAiSaveConfirm] = useState(false);
  const [savingTemplate, setSavingTemplate] = useState(false);
  const [editorLoading, setEditorLoading] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState<Template | null>(null);
  const [deleting, setDeleting] = useState(false);
  const [cloneTarget, setCloneTarget] = useState<Template | null>(null);
  const cloneInFlightRef = useRef(false);
  const [showGallery, setShowGallery] = useState(false);
  const [activeEditorId, setActiveEditorId] = useState("editor1");
  const [generatorPrompt, setGeneratorPrompt] = useState("");
  const [generatingTemplate, setGeneratingTemplate] = useState(false);
  const [search, setSearch] = useState("");
  const [showEmptyTreatmentConfirm, setShowEmptyTreatmentConfirm] = useState(false);
  const [emptyTreatmentSearch, setEmptyTreatmentSearch] = useState("");
   const [templateNameError, setTemplateNameError] = useState("");
  
 
  // Gallery states
  const [galleryTab, setGalleryTab] = useState<"private" | "stock_gifs">("private");
  const [gallerySearch, setGallerySearch] = useState("");
  const [galleryLoading, setGalleryLoading] = useState(false);
  const [galleryData, setGalleryData] = useState({
    stock_gifs: [],
   
    private: [],
  });
  const [showGoogleImageSearch, setShowGoogleImageSearch] = useState(false);

const fetchSideGalleryData = async (
  searchValue = gallerySearch,
  tabValue = galleryTab
) => {
  try {
    const token = axios.defaults.headers.common.Authorization;
    if (!token) return;

    setGalleryLoading(true);

    const res = await axios.get(
      `/consent_clause/get_user_media?search=${encodeURIComponent(searchValue)}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    

    setGalleryData({
      stock_gifs: Array.isArray(res.data?.stock_gifs) ? res.data.stock_gifs : [],
     
      private: Array.isArray(res.data?.private) ? res.data.private : [],
    });
  } catch (error) {
    console.error("Failed to load side gallery data:", error);
  } finally {
    setGalleryLoading(false);
  }
};

const openGoogleImageSearch = () => setShowGoogleImageSearch(true);

useEffect(() => {
  if (!showGallery) return;
  fetchSideGalleryData();
}, [showGallery]);

useEffect(() => {
  if (!showGallery) return;

  const timer = setTimeout(() => {
    fetchSideGalleryData(gallerySearch, galleryTab);
  }, 350);

  return () => clearTimeout(timer);
}, [gallerySearch, galleryTab, showGallery]);


const insertGalleryImageToEditor = (url: string) => {
  const editor = window.CKEDITOR?.instances?.[activeEditorId || "editor1"];
  if (!editor) return;

  editor.insertHtml(`<img src="${url}" alt="" />`);
  setShowGallery(false);
};
 

const [uploadedImage, setUploadedImage] = useState<File | null>(null);
const [uploadedImagePreview, setUploadedImagePreview] = useState<string>("");
const [uploading, setUploading] = useState(false);
const [showUploadModal, setShowUploadModal] = useState(false);


const handleImageUpload = async () => {
  const token = axios.defaults.headers.common.Authorization;

  if (!token) {
    toast.error("Authorization token is missing.");
    return;
  }

  if (!uploadedImage) {
    toast.error("No image selected.");
    return;
  }

  try {
    setUploading(true);

    const fileSizeInMB = uploadedImage.size / (1024 * 1024);

    if (fileSizeInMB > 2) {
      toast.error(`${uploadedImage.name} is too large. Maximum allowed size is 2MB.`);
      return;
    }

    const formData = new FormData();
    formData.append("file", uploadedImage);
    formData.append("user_file_name", uploadedImage.name);

    await axios.post("/consent_clause/upload_user_media_to_s3", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    });

    toast.success("Content added to the image gallery.");

    if (uploadedImagePreview) {
      URL.revokeObjectURL(uploadedImagePreview);
    }

    setUploadedImage(null);
    setUploadedImagePreview("");
    setShowUploadModal(false);

    await fetchSideGalleryData();
  } catch (error) {
    console.error("Error uploading image:", error);
    toast.error("Failed to upload image.");
  } finally {
    setUploading(false);
  }
};

const clearSelectedUpload = () => {
  if (uploadedImagePreview) {
    URL.revokeObjectURL(uploadedImagePreview);
  }

  setUploadedImage(null);
  setUploadedImagePreview("");
};


const [isDragOver, setIsDragOver] = useState(false);

const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];

  if (!file) return;

  if (!file.type.startsWith("image/")) {
    toast.error("Please select a valid image file.");
    return;
  }

  if (uploadedImagePreview) {
    URL.revokeObjectURL(uploadedImagePreview);
  }

  setUploadedImage(file);
  setUploadedImagePreview(URL.createObjectURL(file));
};

const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
  e.preventDefault();
  e.stopPropagation();
  setIsDragOver(false);

  const file = e.dataTransfer.files?.[0];

  if (!file) return;

  if (!file.type.startsWith("image/")) {
    toast.error("Please drop a valid image file.");
    return;
  }

  if (uploadedImagePreview) {
    URL.revokeObjectURL(uploadedImagePreview);
  }

  setUploadedImage(file);
  setUploadedImagePreview(URL.createObjectURL(file));
};

const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
  e.preventDefault();
  e.stopPropagation();
  setIsDragOver(true);
};

const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
  e.preventDefault();
  e.stopPropagation();
  setIsDragOver(false);
};

  // Gallery states


  

  const getToken = () =>
    axios.defaults.headers.common.Authorization?.replace("Bearer ", "") ||
    localStorage.getItem("token") ||
    Cookies.get("token");

  const getTreatmentLabel = (t: Treatment) =>
    t.description || t.name || t.category_name || `Treatment ${t.id}`;

  const countWords = (text: string) =>
    text.trim().split(/\s+/).filter(Boolean).length;

  useEffect(() => {
    const handler = (e: any) => {
      const editorId = e?.detail?.editorId || "editor1";
      setActiveEditorId(editorId);
      setShowGallery(true);
    };

    window.addEventListener("ckeditor-open-gallery", handler as EventListener);
    return () => window.removeEventListener("ckeditor-open-gallery", handler as EventListener);
  }, []);

  const uploadCallback = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    return axios.post("/uploads/image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data } = await axios.get("/user");
        if (Array.isArray(data) && data.length > 1) {
          setUser(data[1]);
        } else {
          setUser(data);
        }
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    if (!user?.level) return;
    setSelectedLevel(user.level === "practice" ? "practice" : "user");
  }, [user?.level]);

  useEffect(() => {
    const fetchTreatments = async () => {
      try {
        const token = getToken();

        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}treatment`, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        setTreatments(res.data?.treatments || []);
      } catch (err) {
        console.error("Failed to load treatments:", err);
        setTreatments([]);
      }
    };

    fetchTreatments();
  }, []);

  const fetchPracticeTemplates = async () => {
  try {
    setLoading(true);

    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BASE_URL}consent_clause?search=`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const defaultTemplates = Array.isArray(res.data?.consent_form_templates)
      ? res.data.consent_form_templates
      : [];

    const nonDefaultTemplates = Array.isArray(res.data?.non_default_consent_form_templates)
      ? res.data.non_default_consent_form_templates
      : [];

    setPracticeTemplates([...defaultTemplates, ...nonDefaultTemplates]);
  } catch (err) {
    console.error("Failed to load templates:", err);
    setPracticeTemplates([]);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
  if (!user) return;
  fetchPracticeTemplates();
}, [user]);

  useEffect(() => {
    const fetchGlobalTemplates = async () => {
      if (mode !== "builder" || builderTab !== "existing") return;

      try {
        setLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL_V2}onboarding/get_global_consent_templates`,
          {
            headers: {
              Accept: "application/json",
            },
          }
        );

        setTemplates(res.data || []);
      } catch (err) {
        console.error("Failed to load global templates:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchGlobalTemplates();
  }, [mode, builderTab]);

  useEffect(() => {
      if (!editTemplate) return;

      const destroyAllEditors = () => {
        const instances = window.CKEDITOR?.instances || {};
        Object.keys(instances).forEach((key) => {
          try {
            instances[key].destroy(true);
          } catch (err) {
            console.error(`Failed to destroy CKEditor instance: ${key}`, err);
          }
        });
      };

      const loadEditor = () => {
        if (!editorRef.current) return;

        editorRef.current.id = "editor1";
        destroyAllEditors();
        setEditorLoading(true);

        const editor = window.CKEDITOR.replace("editor1", {
          height: 450,
          extraPlugins:
            "placeholder_select,simpleImageUpload,image2,image,signaturebuttons,gallerybutton,uploadimage",
          toolbar: [
            { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike"] },
            {
              name: "paragraph",
              items: ["NumberedList", "BulletedList", "Outdent", "Indent", "Blockquote"],
            },
            { name: "links", items: ["Link", "Unlink"] },
            { name: "styles", items: ["Format", "Font", "FontSize"] },
            { name: "colors", items: ["TextColor", "BGColor"] },
            {
              name: "insert",
              items: [
                "GalleryButton",
                "SignatureMandatory",
                "SignatureOptional",
                "ClinicianSignature",
              ],
            },
          ],
          allowedContent: true,
          image2_disableResizer: false,
          image_prefillDimensions: true,
        });

        editor.on("instanceReady", () => {
          editor.setData(editTemplate.body || "", {
            callback: () => {
              setEditorLoading(false);
            },
          });
        });

        editor.on("dataReady", () => {
          setEditorLoading(false);
        });

        setActiveEditorId(editor.name || "editor1");
      };

      setEditorLoading(true);

      if (!window.CKEDITOR) {
        const existingScript = document.querySelector('script[src="/ckeditor/ckeditor.js"]');
        if (!existingScript) {
          const script = document.createElement("script");
          script.src = "/ckeditor/ckeditor.js";
          script.onload = loadEditor;
          document.body.appendChild(script);
        } else {
          loadEditor();
        }
      } else {
        loadEditor();
      }

      return () => {
        setEditorLoading(false);
        destroyAllEditors();
      };
    }, [editTemplate?.id]);


  const openGlobalTemplateEditor = (template: Template) => {
    const initialLevel = getInitialLevel();

    setEditTemplate({
      ...template,
      treatment_ids: [],
      treatment_id: null,
      level: initialLevel,
      is_default: false,
    });

    setSelectedTreatments([]);
    setSelectedLevel(initialLevel);
    setTreatmentSearch("");
    setDropdownOpen(false);
    setPreview(null);
    setMode("builder");
  };

  const handleEditPracticeTemplate = (template: Template) => {
  const resolvedLevel: "user" | "practice" =
    template.level === "practice" ? "practice" : "user";

  setEditTemplate({
    ...template,
    level: resolvedLevel,
    is_default: !!template.is_default,
  });

  setSelectedLevel(resolvedLevel);
  setSelectedTreatments(template.treatment_ids || []);
  setTreatmentSearch("");
  setDropdownOpen(false);
  setPreview(null);
  setMode("builder");
};

  const handleGenerateTemplate = async () => {
    const trimmedPrompt = generatorPrompt.trim();
    const wordCount = countWords(trimmedPrompt);

    if (!trimmedPrompt) {
      toast.error("Please enter a treatment prompt.");
      return;
    }

    if (wordCount > 20) {
      toast.error("Prompt must be 20 words or fewer.");
      return;
    }

    try {
      setGeneratingTemplate(true);

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL_V2}template_generator/generate-template`,
        {
          treatment_item: trimmedPrompt,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const generatedHtml =
        res.data?.html ||
        res.data?.body ||
        res.data?.template ||
        res.data?.data?.html ||
        res.data;

      if (typeof generatedHtml !== "string" || !generatedHtml.trim()) {
        throw new Error("Template generator returned an invalid HTML response.");
      }

      setSelectedTreatments([]);
      setTreatmentSearch("");
      setDropdownOpen(false);

      setEditTemplate({
        id: 0,
        name: trimmedPrompt,
        body: generatedHtml,
        level: user?.level === "practice" ? "practice" : "user",
        is_default: false,
        is_cloned: false,
        parent_id: null,
        category_id: null,
        treatment_id: null,
        treatment_ids: [],
        type: undefined,
        practice_id: null,
      });

      toast.info("Draft generated. Review and save it to add it to your templates.");
    } catch (err: any) {
      console.error(err);

      const backendMessage =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Failed to generate template";

      toast.error(
        typeof backendMessage === "string"
          ? backendMessage
          : JSON.stringify(backendMessage)
      );
    } finally {
      setGeneratingTemplate(false);
    }
  };

  const saveTemplate = async () => {
  if (!editTemplate) return;

  try {
    setSavingTemplate(true);

    const editorContent =
      window.CKEDITOR?.instances?.editor1?.getData?.() ?? editTemplate.body ?? "";

    let updatedContent = editorContent;

    const base64Regex = /<img[^>]+src="(data:image\/[^;]+;base64,[^"]+)"[^>]*>/g;
    const matches = [...editorContent.matchAll(base64Regex)];

    for (const match of matches) {
      const base64Data = match[1];
      if (!base64Data) continue;

      const blob = await fetch(base64Data).then((res) => res.blob());
      const file = new File([blob], "upload.png", { type: blob.type });
      const uploadRes = await uploadCallback(file);

      const uploadedUrl =
        uploadRes?.data?.url ||
        uploadRes?.data?.data?.url ||
        uploadRes?.data?.path ||
        uploadRes?.data;

      if (typeof uploadedUrl === "string") {
        updatedContent = updatedContent.replace(base64Data, uploadedUrl);
      }
    }

    const token = getToken();

    const isEditingExistingPrivateTemplate =
      !!editTemplate.id &&
      practiceTemplates.some((t) => t.id === editTemplate.id);

    const commonPayload = {
      name: editTemplate.name,
      body: updatedContent,
      level: selectedLevel,
      is_default: !!editTemplate.is_default,
      treatment_id: selectedTreatments.length > 0 ? selectedTreatments[0] : null,
      treatment_ids: selectedTreatments,
    };

    if (isEditingExistingPrivateTemplate) {
      const payload = {
        ...commonPayload,
        is_cloned: editTemplate.is_cloned ?? false,
        parent_id: editTemplate.parent_id ?? null,
        category_id: editTemplate.category_id ?? null,
      };

      await axios.put(
        `${process.env.REACT_APP_BASE_URL}consent_clause/${editTemplate.id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } else if (builderTab === "existing" && editTemplate.id) {
      const payload = {
        ...commonPayload,
        is_cloned: false,
        parent_id: null,
      };

      await axios.put(
        `${process.env.REACT_APP_BASE_URL}consent_clause/${editTemplate.id}/copy_global_template_to_private`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } else {
      const payload = {
        ...commonPayload,
        is_cloned: false,
        parent_id: null,
        category_id: null,
      };

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}consent_clause`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }

    toast.success("Template saved successfully");
    setShowAiSaveConfirm(false);
    setEditTemplate(null);
    setMode("empty");
    setBuilderTab("existing");
    setSelectedTreatments([]);
    setTreatmentSearch("");
    setGeneratorPrompt("");
    await fetchPracticeTemplates();
  } catch (err: any) {
    console.error(err);

    const backendMessage =
      err?.response?.data?.detail ||
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.response?.data?.title ||
      "Failed to save template";

    toast.error(
      typeof backendMessage === "string"
        ? backendMessage
        : JSON.stringify(backendMessage)
    );
  } finally {
    setSavingTemplate(false);
  }
};


const handleSave = async () => {
  if (!editTemplate) return;

  if (!editTemplate.name?.trim()) {
    setTemplateNameError("Template name is required");
    return;
  }

  setTemplateNameError("");

  if (selectedTreatments.length === 0) {
    setShowEmptyTreatmentConfirm(true);
    return;
  }

  const isEditingExistingPrivateTemplate =
    !!editTemplate.id &&
    practiceTemplates.some((t) => t.id === editTemplate.id);

  const isAiGeneratedTemplate =
    builderTab === "generate" && !isEditingExistingPrivateTemplate;

  if (isAiGeneratedTemplate) {
    setShowAiSaveConfirm(true);
    return;
  }

  await saveTemplate();
};

//   const handleNext = () => navigate("/previewComplete");
//   const handleBack = () => navigate("/portfolioGallery");

  const handlePreviewFromEditor = () => {
    if (!editTemplate) return;

    const editorContent =
      window.CKEDITOR?.instances?.editor1?.getData?.() || editTemplate.body;

    setPreview({
      ...editTemplate,
      body: editorContent,
    });
  };

  const filteredTreatments = treatments.filter((t) => {
    const label = getTreatmentLabel(t).toLowerCase();
    return (
      label.includes(treatmentSearch.toLowerCase()) &&
      !selectedTreatments.includes(t.id)
    );
  });

  const confirmDeleteTemplate = async () => {
  if (!deleteTarget) return;

  if (deleteTarget.type === "intro" || deleteTarget.type === "outro") {
    toast.error("Intro and outro templates cannot be deleted.");
    setDeleteTarget(null);
    return;
  }

  try {
    setDeleting(true);
    const token = getToken();

    await axios.delete(
      `${process.env.REACT_APP_BASE_URL}consent_clause/${deleteTarget.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("Template deleted successfully");
    setDeleteTarget(null);
    await fetchPracticeTemplates();
  } catch (err) {
    console.error(err);
    toast.error("Failed to delete template");
  } finally {
    setDeleting(false);
  }
};

  const generatorWordCount = countWords(generatorPrompt);
  const isGeneratorPromptTooLong = generatorWordCount > 20;


const openManualTemplateEditor = () => {
  setEditTemplate({
    id: 0,
    name: "",
    body: "",
    level: user?.level === "practice" ? "practice" : "user",
    treatment_ids: [],
    category_id: null,
    treatment_id: null,
    is_default: false,
    is_cloned: false,
    parent_id: null,
  });

  setSelectedTreatments([]);
  setTreatmentSearch("");
  setDropdownOpen(false);
};

const handleCloneTemplate = (t: Template) => {
  if (cloneInFlightRef.current) return;
  if (t.type === "intro" || t.type === "outro") {
    toast.error("Intro and outro templates cannot be cloned.");
    return;
  }

  cloneConsentTemplate.reset();
  setCloneTarget(t);
};

const cloneConsentTemplate = useMutation(
  (clause: Template) =>
    axios.put(`${process.env.REACT_APP_BASE_URL}consent_clause/${clause.id}/clone`),
  {
    retry: false,
    onSuccess: async (res) => {
      const cloned = res.data;
      setCloneTarget(null);

      const normalizedLevel: "user" | "practice" =
        cloned?.level === "practice" ? "practice" : "user";

      const normalizedTreatmentIds: number[] = Array.isArray(cloned?.treatment_ids)
        ? cloned.treatment_ids
        : cloned?.treatment_id
        ? [cloned.treatment_id]
        : [];

      setEditTemplate({
        ...cloned,
        level: normalizedLevel,
        treatment_id:
          cloned?.treatment_id ?? normalizedTreatmentIds[0] ?? null,
        treatment_ids: normalizedTreatmentIds,
      });

      setSelectedLevel(normalizedLevel);
      setSelectedTreatments(normalizedTreatmentIds);

      setTreatmentSearch("");
      setDropdownOpen(false);
      setPreview(null);
      setMode("builder");
      setBuilderTab("manual");

      toast.success("Template cloned successfully");
      await fetchPracticeTemplates();
    },
    onError: (err) => {
      console.error(err);
      toast.error("Failed to clone template");
    },
    onSettled: () => {
      cloneInFlightRef.current = false;
    },
  }
);

const confirmCloneTemplate = () => {
  if (!cloneTarget || cloneInFlightRef.current) return;
  cloneInFlightRef.current = true;
  cloneConsentTemplate.mutate(cloneTarget);
};

const closeCloneConfirmation = () => {
  if (cloneInFlightRef.current) return;
  setCloneTarget(null);
  cloneConsentTemplate.reset();
};

const getTemplateTreatmentLabels = (template: Template) => {
  if (!Array.isArray(template.treatment_ids) || template.treatment_ids.length === 0) {
    return [];
  }

  return template.treatment_ids
    .map((treatmentId) => treatments.find((tr) => tr.id === treatmentId))
    .filter(Boolean)
    .map((tr) => getTreatmentLabel(tr as Treatment));
};


const getInitialLevel = (): "user" | "practice" =>
  user?.level === "practice" ? "practice" : "user";

const handleLevelCheckboxChange = (level: "user" | "practice") => {
  setSelectedLevel(level);
  setEditTemplate((prev) =>
    prev
      ? {
          ...prev,
          level,
        }
      : prev
  );
};

const handleDefaultCheckboxChange = (checked: boolean) => {
  setEditTemplate((prev) =>
    prev
      ? {
          ...prev,
          is_default: checked,
        }
      : prev
  );
};

const openCreateTemplate = () => {
  const initialLevel = getInitialLevel();

  setMode("builder");
  setBuilderTab("manual");
  setPreview(null);
  setSelectedTreatments([]);
  setTreatmentSearch("");
  setDropdownOpen(false);
  setGeneratorPrompt("");
  setSelectedLevel(initialLevel);

  setEditTemplate({
    id: 0,
    name: "",
    body: "",
    level: initialLevel,
    is_default: false,
    is_cloned: false,
    parent_id: null,
    category_id: null,
    treatment_id: null,
    treatment_ids: [],
    type: undefined,
    practice_id: null,
  });
};


const isLockedTemplateType = (template?: Template | null) =>
  template?.type === "intro" || template?.type === "outro";


const filteredModalTreatments = treatments.filter((t) =>
  getTreatmentLabel(t).toLowerCase().includes(emptyTreatmentSearch.toLowerCase())
);

const normalizedTemplateSearch = search.trim().toLowerCase();
const filteredPracticeTemplates = practiceTemplates.filter((template) =>
  (template.name || "").toLowerCase().includes(normalizedTemplateSearch)
);

  return (
    <div className={styles.page}>
      <Header />

      <main className={styles.main}>
        {/* <SetupSteps
          steps={STEPS}
          current={5}
          rightLabel="80% Complete"
          onStepClick={(step) => navigate(step.path)}
        /> */}

        {mode === "empty" ? (
          <>
            <h1 className={styles.title}>Consent Templates</h1>
            <p className={styles.subtitle}>
              Create consent templates for your most common procedures.
            </p>

            <section className={styles.card}>
              <div className={styles.cardHeader}>
                <h2>Your Templates ({filteredPracticeTemplates.length})</h2>
                <div className={styles.headerActions}>
                    <SearchInput onClear={() => { setSearch(""); }}
                    type="text"
                    placeholder="Search templates..."
                    className={styles.searchInput}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    />
                    <button
                    className={styles.createBtnSmall}
                    onClick={() => {
                        setMode("builder");
                        setBuilderTab("existing");
                        setEditTemplate(null);
                        setSelectedTreatments([]);
                        setTreatmentSearch("");
                        setGeneratorPrompt("");
                    }}
                    >
                    + Create New Template
                    </button>
                </div>
                </div>

              {loading ? (
                <div className={styles.loading}>Loading...</div>
              ) : (
                <div className={styles.practiceTemplatesList}>
                  {filteredPracticeTemplates.map((t) => {
                    const treatmentLabels = getTemplateTreatmentLabels(t);
                    return (
                        <div key={t.id} className={styles.practiceTemplateItem}>
                        <div className={styles.templateInfo}>
                            <div className={styles.templateNameRow}>
                            <div className={styles.templateMeta}>
                                {t.is_default && (
                                <span
                                    className={`${styles.metaBadge} ${styles.defaultBadge}`}
                                    title="Default template"
                                >
                                    <CheckCircleRoundedIcon />
                                </span>
                                )}
                                
                                {t.level === "practice" ? (
                                <span
                                    className={`${styles.metaBadge} ${styles.practiceBadge}`}
                                    title="Practice template"
                                >
                                    <BusinessRoundedIcon />
                                </span>
                                ) : t.level === "user" ? (
                                <span
                                    className={`${styles.metaBadge} ${styles.userBadge}`}
                                    title="User template"
                                >
                                    <PersonRoundedIcon />
                                </span>
                                ) : null}
                            </div>

                            <div className={styles.templateTextBlock}>
                                <div className={styles.templateName}>{t.name}</div>

                                {treatmentLabels.length > 0 && (
                                <div className={styles.treatmentBubbleWrap}>
                                    {treatmentLabels.map((label, index) => (
                                    <span key={`${t.id}-${index}`} className={styles.treatmentBubble}>
                                        {label}
                                    </span>
                                    ))}
                                </div>
                                )}
                            </div>
                            </div>
                        </div>

                        <div className={styles.actions}>
                            <button
                            className={styles.iconBtn}
                            onClick={() => setPreview(t)}
                            data-label="View"
                            >
                            <VisibilityOutlinedIcon />
                            </button>

                            <button
                            className={styles.iconBtn}
                            onClick={() => handleEditPracticeTemplate(t)}
                            data-label="Edit"
                            >
                            <EditOutlinedIcon />
                            </button>

                           {!isLockedTemplateType(t) && (
  <>
    <button
      className={styles.iconBtn}
      onClick={() => handleCloneTemplate(t)}
      data-label="Clone"
      aria-label={`Clone ${t.name}`}
      disabled={cloneConsentTemplate.isLoading}
    >
      <ContentCopyOutlinedIcon />
    </button>

    <button
      className={`${styles.iconBtn} ${styles.deleteBtn}`}
      onClick={() => setDeleteTarget(t)}
      data-label="Delete"
    >
      <DeleteOutlineOutlinedIcon />
    </button>
  </>
)}
                        </div>
                        </div>
                    );
                    })}
                </div>
              )}
            </section>
          </>
        ) : (
          <>
          <div className={styles.builderHeader}>
              <h1>Create Consent Template</h1>

              <button
                className={styles.backToListBtn}
                onClick={() => {
                  setMode("empty");
                  setBuilderTab("existing");
                  setEditTemplate(null);
                  setGeneratorPrompt("");
                }}
              >
                ← Back To List
              </button>
          </div>

            <section className={styles.card}>
              <div className={styles.builderTabs}>
                <button
                    type="button"
                    className={`${styles.builderTabBtn} ${
                    builderTab === "manual" ? styles.activeTab : ""
                    }`}
                    onClick={() => {
                    setBuilderTab("manual");
                    openManualTemplateEditor();
                    setGeneratorPrompt("");
                    }}
                >
                    + Create Template Manually
                </button>

                <button
                    type="button"
                    className={`${styles.builderTabBtn} ${
                    builderTab === "existing" ? styles.activeTab : ""
                    }`}
                    onClick={() => {
                    setBuilderTab("existing");
                    setEditTemplate(null);
                    setSelectedTreatments([]);
                    setTreatmentSearch("");
                    setGeneratorPrompt("");
                    }}
                >
                    Use Global Template
                </button>

                <button
                    type="button"
                    className={`${styles.generateTemplateBtn} ${
                    builderTab === "generate" ? styles.generateTemplateBtnActive : ""
                    }`}
                    onClick={() => {
                    setBuilderTab("generate");
                    setEditTemplate(null);
                    setSelectedTreatments([]);
                    setTreatmentSearch("");
                    }}
                >
                    <span className={styles.generateTemplateGlow} />
                    <span className={styles.generateTemplateInner}>
                    <HiSparkles className={styles.generateTemplateIcon} />
                    <span className={styles.generateTemplateText}>Generate Template</span>
                    </span>
                </button>
            </div>

              {builderTab === "existing" ? (
                <>
                  <div className={styles.builderTabIntro}>
                    Select a global consent template and customize it for your practice.
                  </div>

                  {loading ? (
                    <div className={styles.loading}>Loading...</div>
                  ) : (
                    <div className={styles.templatesGrid}>
                      {templates.map((t) => (
                        <div
                          key={t.id}
                          className={styles.templateItem}
                          onClick={() => openGlobalTemplateEditor(t)}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              openGlobalTemplateEditor(t);
                            }
                          }}
                        >
                          <div className={styles.templateName}>{t.name}</div>
                          <FiEdit2 className={styles.editIcon} />
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div className={styles.generateTemplateSection}>
  <div className={styles.generateHero}>
    <div className={styles.generateHeroContent}>
      <h2>Generate a New Consent Template</h2>
      <p>
        Describe the treatment in a short prompt and we will generate an editable
        consent template for you. You can then rename it, assign treatments,
        and update the content in the editor.
      </p>
    </div>

    <div className={styles.generateHeroBadge}>
      <span>AI Assisted</span>

       <div className={styles.generateHeroBadgeExperimental}>
      <span>Experimental </span>
    </div>

    </div>
  </div>

  <div className={styles.generateLayout}>
    <div className={styles.generateMainCard}>
      <div className={styles.generateCardHeader}>
        <h3>Treatment Prompt</h3>
        <p>Keep the prompt short and specific. Maximum 20 words.</p>
      </div>

      <div className={styles.generateInputWrap}>
        <textarea
          className={styles.generateTextarea}
          rows={5}
          value={generatorPrompt}
          onChange={(e) => setGeneratorPrompt(e.target.value)}
          placeholder="Example: Composite bonding for chipped front tooth repair"
          disabled={generatingTemplate}
        />

        <div className={styles.generateMetaRow}>
          <div
            className={`${styles.wordCount} ${
              isGeneratorPromptTooLong ? styles.wordCountError : ""
            }`}
          >
            {generatorWordCount}/20 words
          </div>

          <div className={styles.generateHint}>
            A short treatment-focused phrase works best.
          </div>
        </div>
      </div>

      <div className={styles.generateActions}>
        <button
          className={styles.generateBtn}
          onClick={handleGenerateTemplate}
          disabled={generatingTemplate || isGeneratorPromptTooLong || !generatorPrompt.trim()}
        >
          {generatingTemplate ? (
            <span className={styles.generateBtnInner}>
              <span className={styles.buttonSpinner} />
              Generating Template...
            </span>
          ) : (
            <span className={styles.generateBtnInner}>
              <HiSparkles className={styles.aiIcon} />
              Generate Template
            </span>
          )}
        </button>
      </div>
    </div>

    <div className={styles.generateSideCard}>
      <h3>Prompt Tips</h3>

      <div className={styles.tipList}>
        <div className={styles.tipItem}>
          <strong>Be specific</strong>
          <span>Include the treatment name and short context.</span>
        </div>

        <div className={styles.tipItem}>
          <strong>Keep it short</strong>
          <span>Do not exceed 20 words.</span>
        </div>

        <div className={styles.tipItem}>
          <strong>Use plain language</strong>
          <span>Avoid combining too many procedures in one prompt.</span>
        </div>
      </div>

      <div className={styles.exampleBlock}>
        <div className={styles.exampleTitle}>Examples</div>

        <button
          type="button"
          className={styles.examplePrompt}
          onClick={() =>
            !generatingTemplate &&
            setGeneratorPrompt("Composite bonding for chipped upper front tooth")
          }
        >
          Composite bonding for chipped upper front tooth
        </button>

        <button
          type="button"
          className={styles.examplePrompt}
          onClick={() =>
            !generatingTemplate &&
            setGeneratorPrompt("Root canal treatment for lower molar with crown advice")
          }
        >
          Root canal treatment for lower molar with crown advice
        </button>

        <button
          type="button"
          className={styles.examplePrompt}
          onClick={() =>
            !generatingTemplate &&
            setGeneratorPrompt("Simple extraction for painful broken tooth")
          }
        >
          Simple extraction for painful broken tooth
        </button>
      </div>
    </div>
  </div>

  {generatingTemplate && (
    <div className={styles.generateLoadingOverlay}>
      <div className={styles.generateLoadingCard}>
        <div className={styles.generateSpinner} />
        <h3>Generating template...</h3>
        <p>Analysing your prompt and building an editable consent draft.</p>
      </div>
    </div>
  )}
</div>
              )}
            </section>
          </>
        )}

        <Dialog
          open={Boolean(cloneTarget)}
          onClose={closeCloneConfirmation}
          disableEscapeKeyDown={cloneConsentTemplate.isLoading}
          maxWidth="xs"
          fullWidth
          aria-labelledby="clone-template-title"
          aria-describedby="clone-template-description"
          PaperProps={{ sx: { borderRadius: "20px" } }}
        >
          <DialogTitle id="clone-template-title">Clone template?</DialogTitle>
          <DialogContent>
            <p id="clone-template-description">
              Create a copy of <strong>“{cloneTarget?.name}”</strong>?
            </p>
            <p className={styles.helpText}>
              The copy will be saved immediately and opened for editing.
            </p>
            {cloneConsentTemplate.isError && (
              <p className={styles.inlineError} role="alert">
                The template could not be cloned. Please try again.
              </p>
            )}
          </DialogContent>
          <DialogActions sx={{ padding: "0 24px 24px", gap: "8px" }}>
            <button
              type="button"
              className={styles.cancelBtn}
              onClick={closeCloneConfirmation}
              disabled={cloneConsentTemplate.isLoading}
              autoFocus
            >
              Cancel
            </button>
            <button
              type="button"
              className={styles.saveTemplateBtn}
              onClick={confirmCloneTemplate}
              disabled={cloneConsentTemplate.isLoading}
            >
              {cloneConsentTemplate.isLoading ? "Cloning..." : "Clone template"}
            </button>
          </DialogActions>
        </Dialog>

        {deleteTarget && (
            <div className={styles.modalOverlay} onClick={() => setDeleteTarget(null)}>
                <div
                className={styles.confirmModal}
                onClick={(e) => e.stopPropagation()}
                >
                <div className={styles.modalHeader}>
                    <h3>Delete Template</h3>
                    <button
                    className={styles.closeBtn}
                    onClick={() => setDeleteTarget(null)}
                    >
                    ✕
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <p>
                    Are you sure you want to delete
                    <strong> “{deleteTarget.name}”</strong>?
                    </p>
                    <p className={styles.warningText}>This action cannot be undone.</p>
                </div>

                <div className={styles.modalFooter}>
                    <button
                    className={styles.cancelBtn}
                    onClick={() => setDeleteTarget(null)}
                    disabled={deleting}
                    >
                    Cancel
                    </button>

                    <button
                    className={styles.deleteConfirmBtn}
                    onClick={confirmDeleteTemplate}
                    disabled={deleting}
                    >
                    {deleting ? "Deleting..." : "Delete"}
                    </button>
                </div>
                </div>
            </div>
            )}

        
      </main>

        {editTemplate && (
            <div className={styles.modalOverlay} onClick={() => setEditTemplate(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                <h2>
                    {builderTab === "existing" && editTemplate.id
                    ? "Edit Global Template"
                    : "Generated Template"}
                </h2>
                <button className={styles.closeBtn} onClick={() => setEditTemplate(null)}>
                    ✕
                </button>
                </div>

                <div className={styles.modalBody}>
                    <div
                      className={`${styles.editorLayout} ${
                        showGallery ? styles.editorLayoutGalleryOpen : ""
                      }`}
                    >
                      <div className={styles.editorMain}>
                        <div className={styles.fieldGroup}>
  <label className={styles.fieldLabel}>
    Template Name <span className={styles.required}>*</span>
  </label>

  <input
    type="text"
    className={`${styles.nameInput} ${templateNameError ? styles.inputError : ""}`}
    value={editTemplate?.name || ""}
    onChange={(e) => {
      const value = e.target.value;
      setEditTemplate({ ...editTemplate, name: value });

      if (value.trim()) {
        setTemplateNameError("");
      }
    }}
    placeholder="Enter template name"
  />

  {templateNameError && (
    <div className={styles.inlineError}>{templateNameError}</div>
  )}
</div>

                        <div className={styles.formGroup}>
                          <label className={styles.fieldLabel}>Select Treatments</label>

                          <div className={styles.treatmentPicker}>
                            <div className={styles.treatmentPickerTop}>
                              <div className={styles.treatmentPickerTitle}>Assigned treatments</div>
                              <div className={styles.treatmentPickerCount}>
                                {selectedTreatments.length} selected
                              </div>
                            </div>

                            <div className={styles.multiSelectBox}>
                              <div className={styles.selectedChips}>
                                {selectedTreatments.map((id) => {
                                  const treatment = treatments.find((t) => t.id === id);

                                  return (
                                    <div key={id} className={styles.chip}>
                                      <span className={styles.chipText}>
                                        {treatment ? getTreatmentLabel(treatment) : `Treatment ${id}`}
                                      </span>

                                      <span
                                        className={styles.removeChip}
                                        onClick={() =>
                                          setSelectedTreatments((prev) => prev.filter((x) => x !== id))
                                        }
                                      >
                                        ✕
                                      </span>
                                    </div>
                                  );
                                })}

                                <div className={styles.searchSelectWrapper}>
                                  <SearchInput onClear={() => { setTreatmentSearch(""); }}
                                    type="text"
                                    placeholder="Search treatments..."
                                    className={styles.treatmentSearchInput}
                                    value={treatmentSearch}
                                    onChange={(e) => {
                                      setTreatmentSearch(e.target.value);
                                      setDropdownOpen(true);
                                    }}
                                    onFocus={() => setDropdownOpen(true)}
                                  />

                                  {dropdownOpen && filteredTreatments.length > 0 && (
                                    <div className={styles.dropdownList}>
                                      {filteredTreatments.map((t) => (
                                        <div
                                          key={t.id}
                                          className={styles.dropdownItem}
                                          onClick={() => {
                                            setSelectedTreatments((prev) => [...prev, t.id]);
                                            setTreatmentSearch("");
                                            setDropdownOpen(false);
                                          }}
                                        >
                                          {getTreatmentLabel(t)}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <textarea
                          id="editor1"
                          ref={editorRef}
                          className={styles.editorTextarea}
                          defaultValue={editTemplate.body}
                        />

                      <div className={styles.templateOptionsRow}>
                        <label className={styles.optionCheckbox}>
                          <input
                            type="checkbox"
                            checked={selectedLevel === "user"}
                            onChange={() => handleLevelCheckboxChange("user")}
                          />
                          <span>User</span>
                        </label>

                        <label className={styles.optionCheckbox}>
                          <input
                            type="checkbox"
                            checked={selectedLevel === "practice"}
                            onChange={() => handleLevelCheckboxChange("practice")}
                          />
                          <span>Practice</span>
                        </label>

                        <label
                          className={`${styles.optionCheckbox} ${styles.defaultOptionCheckbox}`}
                        >
                          <input
                            type="checkbox"
                            checked={!!editTemplate.is_default}
                            onChange={(e) => handleDefaultCheckboxChange(e.target.checked)}
                          />
                          <span>Mark as default</span>
                        </label>
                    </div>


                      </div>

                                  {showGallery && (
                                    <div className={styles.gallerySidePanel}>
                                      <div className={styles.gallerySidePanelHeader}>
                                        <div className={styles.gallerySidePanelTitle}>Image Gallery</div>

                                        <div className={styles.gallerySidePanelActions}>
                                          <button
                                            type="button"
                                            className={styles.galleryIconButton}
                                            onClick={() => fetchSideGalleryData()}
                                            title="Refresh"
                                          >
                                            ↻
                                          </button>

                                          <button
                                    type="button"
                                    className={styles.galleryUploadButton}
                                    onClick={() => setShowUploadModal(true)}
                                  >
                                    Upload
                                  </button>

                                          <button
                                            type="button"
                                            className={styles.galleryIconButton}
                                            onClick={() => setShowGallery(false)}
                                            title="Close"
                                          >
                                            ✕
                                          </button>
                                        </div>
                                      </div>

                                      <div className={styles.galleryTabs}>
                                        <button
                                          type="button"
                                          className={`${styles.galleryTabBtn} ${
                                            galleryTab === "private" ? styles.galleryTabBtnActive : ""
                                          }`}
                                          onClick={() => {
                                            setGalleryTab("private");
                                            setGallerySearch("");
                                            fetchSideGalleryData("", "private");
                                          }}
                                        >
                                          Private
                                        </button>

                                        <button
                                          type="button"
                                          className={`${styles.galleryTabBtn} ${
                                            galleryTab === "stock_gifs" ? styles.galleryTabBtnActive : ""
                                          }`}
                                          onClick={() => {
                                            setGalleryTab("stock_gifs");
                                            setGallerySearch("");
                                            fetchSideGalleryData("", "stock_gifs");
                                          }}
                                        >
                                          Stock GIFs
                                        </button>

                                        <button
                                          type="button"
                                          className={styles.googleGalleryTab}
                                          onClick={openGoogleImageSearch}
                                          title="Google Image Search"
                                          aria-label="Open Google Image Search"
                                        >
                                          <GoogleIcon size={20} />
                                        </button>
                                      </div>

                                      <div className={styles.gallerySearchBar}>
                                        <SearchInput onClear={() => { setGallerySearch(""); }}
                                          type="text"
                                          placeholder={
                                            galleryTab === "private"
                                              ? "Search private images..."
                                              : "Search GIFs..."
                                          }
                                          value={gallerySearch}
                                          onChange={(e) => setGallerySearch(e.target.value)}
                                          className={styles.gallerySearchInput}
                                        />
                                      </div>

                                      <div className={styles.gallerySidePanelBody}>
                                        {galleryLoading ? (
                                          <div className={styles.galleryEmptyState}>Loading...</div>
                                        ) : (galleryData[galleryTab] || []).length === 0 ? (
                                          <div className={styles.galleryEmptyState}>No images found</div>
                                        ) : (
                                          <div className={styles.galleryGrid}>
                                            {(galleryData[galleryTab] || []).map((item: any) => (
                                              <button
                                                key={item.id}
                                                type="button"
                                                className={styles.galleryCard}
                                                onClick={() => insertGalleryImageToEditor(item.url)}
                                              >
                                                <img
                                                  src={item.url}
                                                  alt={item.name || "gallery image"}
                                                  className={styles.galleryCardImage}
                                                />

                                                <div className={styles.galleryCardFooter}>
                                                  <span className={styles.galleryCardName}>
                                                    {item.name || item.user_file_name || "Untitled"}
                                                  </span>
                                                </div>
                                              </button>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                    </div>
                </div>

                <div className={styles.modalFooter}>
                <button className={styles.viewBtnOutlined} onClick={handlePreviewFromEditor}>
                    Preview
                </button>

                <button className={styles.saveBtn} onClick={handleSave}>
                    Save Template
                </button>
                </div>
            </div>
            </div>
        )}


        {showAiSaveConfirm && (
        <div
            className={styles.modalOverlay}
            onClick={() => !savingTemplate && setShowAiSaveConfirm(false)}
        >
            <div
            className={styles.aiConfirmModal}
            onClick={(e) => e.stopPropagation()}
            >
            <div className={styles.aiConfirmHeader}>
                <h3>Confirm Save</h3>
                <button
                className={styles.closeBtn}
                onClick={() => !savingTemplate && setShowAiSaveConfirm(false)}
                disabled={savingTemplate}
                >
                ✕
                </button>
            </div>

            <div className={styles.aiConfirmBody}>
                <div className={styles.aiConfirmIconWrap}>
                <HiSparkles size={24} />
                </div>

                <h4 className={styles.aiConfirmTitle}>Review AI-generated content</h4>

                <p className={styles.aiConfirmText}>
                AI-assisted features are experimental and can sometimes be inaccurate.
                Please double-check the output before you proceed.
                </p>
            </div>

            <div className={styles.aiConfirmFooter}>
                <button
                className={styles.aiCancelBtn}
                onClick={() => setShowAiSaveConfirm(false)}
                disabled={savingTemplate}
                >
                Cancel
                </button>

                <button
                className={styles.aiProceedBtn}
                onClick={saveTemplate}
                disabled={savingTemplate}
                >
                {savingTemplate ? "Saving..." : "Yes, Proceed"}
                </button>
            </div>
            </div>
        </div>
        )}



{showEmptyTreatmentConfirm && (
  <div
    className={styles.modalOverlay}
    onClick={() => {
      setShowEmptyTreatmentConfirm(false);
      setEmptyTreatmentSearch("");
    }}
  >
    <div
      className={styles.confirmModal}
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className={styles.confirmTitle}>No treatment IDs added</h3>

      <p className={styles.confirmText}>
        You have not added any treatment IDs. You can select Dentally codes below
        or proceed without them.
      </p>

      <div className={styles.confirmSearchWrap}>
        <SearchInput onClear={() => { setEmptyTreatmentSearch(""); }}
          type="text"
          value={emptyTreatmentSearch}
          onChange={(e) => setEmptyTreatmentSearch(e.target.value)}
          placeholder="Search treatment codes..."
          className={styles.confirmSearchInput}
        />
      </div>

      <div className={styles.confirmTreatmentList}>
        {filteredModalTreatments.length > 0 ? (
          filteredModalTreatments.map((t) => (
            <label key={t.id} className={styles.confirmTreatmentItem}>
              <input
                type="checkbox"
                checked={selectedTreatments.includes(t.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedTreatments((prev) =>
                      prev.includes(t.id) ? prev : [...prev, t.id]
                    );
                  } else {
                    setSelectedTreatments((prev) =>
                      prev.filter((id) => id !== t.id)
                    );
                  }
                }}
              />
              <span>{getTreatmentLabel(t)}</span>
            </label>
          ))
        ) : (
          <div className={styles.confirmEmptyState}>
            No treatment codes found.
          </div>
        )}
      </div>

      <div className={styles.confirmActions}>
        <button
          type="button"
          className={styles.secondaryBtn}
          onClick={() => {
            setShowEmptyTreatmentConfirm(false);
            setEmptyTreatmentSearch("");
          }}
        >
          Go Back
        </button>

        <button
          type="button"
          className={styles.outlineBtn}
          onClick={async () => {
            setSelectedTreatments([]);
            setShowEmptyTreatmentConfirm(false);
            setEmptyTreatmentSearch("");
            await saveTemplate();
          }}
        >
          Save Without Treatment IDs
        </button>

        <button
          type="button"
          className={styles.primaryBtn}
          onClick={async () => {
            setShowEmptyTreatmentConfirm(false);
            setEmptyTreatmentSearch("");

            const isEditingExistingPrivateTemplate =
              !!editTemplate?.id &&
              practiceTemplates.some((t) => t.id === editTemplate.id);

            const isAiGeneratedTemplate =
              builderTab === "generate" && !isEditingExistingPrivateTemplate;

            if (isAiGeneratedTemplate) {
              setShowAiSaveConfirm(true);
              return;
            }

            await saveTemplate();
          }}
        >
          Save Template
        </button>
      </div>
    </div>
  </div>
)}


<GoogleImageGalleryDialog
  open={showGoogleImageSearch}
  zIndex={10000}
  onClose={() => setShowGoogleImageSearch(false)}
  onUploadSuccess={() => {
    setGalleryTab("private");
    setGallerySearch("");
    void fetchSideGalleryData("", "private");
  }}
/>

{showUploadModal && (
  <div
    className={styles.modalOverlay}
    onClick={() => {
      if (uploading) return;
      setShowUploadModal(false);
    }}
  >
    <div
      className={styles.uploadModal}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.uploadModalHeader}>
        <h3>Upload Images</h3>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={() => {
            if (uploading) return;
            setShowUploadModal(false);
          }}
        >
          ✕
        </button>
      </div>

      <div className={styles.uploadModalBody}>
        <label
  htmlFor="gallery-upload-input"
  className={`${styles.dropArea} ${isDragOver ? styles.dropAreaActive : ""}`}
  onDrop={handleDrop}
  onDragOver={handleDragOver}
  onDragLeave={handleDragLeave}
>
  <input
    id="gallery-upload-input"
    type="file"
    accept="image/png,image/jpeg,image/jpg,image/gif"
    className={styles.hiddenFileInput}
    onChange={handleFileChange}
    disabled={uploading}
  />

  {!uploadedImage ? (
    <div className={styles.dropAreaContent}>
      <div className={styles.dropAreaTitle}>Drag and drop an image here</div>
      <div className={styles.dropAreaSubtext}>or click to browse</div>
      <div className={styles.dropAreaHint}>PNG, JPG, JPEG, GIF · max 2MB</div>
    </div>
  ) : (
    <div className={styles.singleUploadPreview}>
      <div className={styles.singleUploadPreviewThumbWrap}>
        <img
          src={uploadedImagePreview}
          alt={uploadedImage.name}
          className={styles.singleUploadPreviewThumb}
        />
      </div>

      <div className={styles.singleUploadPreviewMeta}>
        <div className={styles.singleUploadPreviewName}>{uploadedImage.name}</div>
        <div className={styles.singleUploadPreviewSize}>
          {(uploadedImage.size / (1024 * 1024)).toFixed(2)} MB
        </div>
      </div>
    </div>
  )}
</label>

{uploadedImage && (
  <div className={styles.singleUploadActions}>
    <button
      type="button"
      className={styles.removeUploadBtn}
      onClick={clearSelectedUpload}
      disabled={uploading}
    >
      Remove
    </button>
  </div>
)}
      </div>

      <div className={styles.uploadModalFooter}>
        <button
          type="button"
          className={styles.cancelBtn}
          onClick={() => {
            if (uploading) return;
            setShowUploadModal(false);
          }}
          disabled={uploading}
        >
          Cancel
        </button>

       <button
  type="button"
  className={styles.saveTemplateBtn}
  onClick={handleImageUpload}
  disabled={uploading || !uploadedImage}
>
  {uploading ? "Uploading..." : "Upload"}
</button>
      </div>
    </div>
  </div>
)}

        {/* {showGallery && (
            <div className={styles.galleryOverlay} onClick={() => setShowGallery(false)}>
            <div className={styles.galleryPanel} onClick={(e) => e.stopPropagation()}>
                <ImageGalleryV2
                showGallery={showGallery}
                onClose={() => setShowGallery(false)}
                onSelectImage={(url: string) => {
                    const editor = window.CKEDITOR?.instances?.[activeEditorId || "editor1"];
                    if (!editor) return;
                    editor.insertHtml(`<img src="${url}" alt="" />`);
                    setShowGallery(false);
                }}
                />
            </div>
            </div>
        )} */}







        {preview && (
            <div className={styles.modalOverlay} onClick={() => setPreview(null)}>
            <div
                className={`${styles.modalContent} ${styles.previewModal}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeader}>
                <h2>Preview: {preview.name}</h2>
                <button className={styles.closeBtn} onClick={() => setPreview(null)}>
                    ✕
                </button>
                </div>

                <div className={styles.modalBody}>
                <div
                    className={styles.previewBody}
                    dangerouslySetInnerHTML={{ __html: preview.body }}
                />
                </div>

                <div className={styles.modalFooter}>
                <button
                    className={styles.closeBtnOutlined}
                    onClick={() => setPreview(null)}
                >
                    Close
                </button>
                </div>
            </div>
            </div>
        )}
    </div>
  );
}
